import clsx from 'clsx';
import classes from './LetterContainer.module.scss'
import { getAlphabetLetter } from '../../../../utils/functions';


export default function LetterContainer(props) {

    const { index } = props;

    return (
        <div className={clsx(classes.letterContainer, classes[`position-${index}`])}>
            <div className={classes.circle}/>
            <div className={classes.letter}>{getAlphabetLetter(index)}</div>
        </div>
    );
}